export function isTextInsertable(el: Element | null): boolean {
  if (!el) return false
  if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
    return !el.readOnly && !el.disabled
  }
  return el instanceof HTMLElement && el.isContentEditable
}

export function insertAtCursor(text: string): void {
  if (typeof text !== 'string') return

  const active = document.activeElement

  if (
    active instanceof HTMLInputElement ||
    active instanceof HTMLTextAreaElement
  ) {
    const start = active.selectionStart ?? active.value.length
    const end = active.selectionEnd ?? active.value.length

    active.setRangeText(text, start, end, 'end')
    active.dispatchEvent(new Event('input', { bubbles: true }))
    return
  }

  if (active instanceof HTMLElement && active.isContentEditable) {
    const beforeInput = new InputEvent('beforeinput', {
      bubbles: true,
      cancelable: true,
      inputType: 'insertText',
      data: text
    })

    active.dispatchEvent(beforeInput)

    if (!beforeInput.defaultPrevented) {
      const selection = window.getSelection()
      if (!selection || selection.rangeCount === 0) return

      const range = selection.getRangeAt(0)
      range.deleteContents()

      const textNode = document.createTextNode(text)
      range.insertNode(textNode)

      range.setStartAfter(textNode)
      range.collapse(true)

      selection.removeAllRanges()
      selection.addRange(range)

      active.dispatchEvent(
        new InputEvent('input', {
          bubbles: true,
          inputType: 'insertText',
          data: text
        })
      )
    }
  }
}
